import $ from 'jquery'
import '../scss/module_notfound.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin } from './module_auth_helper';

import './module_common_actions';
import { initNavbar } from './module_header';
import { initSentry } from './module_sentry';

document.addEventListener("DOMContentLoaded", () => {
    initSentry()
    initFirebaseApp()
    manageLogin()
    
    doLast()
    initNavbar()
});